import { HeaderContext } from '@tanstack/react-table';
import { TableHeader } from 'components/Tables/CommonTableHeaders';
import { JudgeEvaluation } from 'data/features/judgeEvaluationsTypes';

export const MyScore = (props: HeaderContext<JudgeEvaluation, number>) => {
  const meta = props.table.options.meta as any;
  return <TableHeader {...props}>{meta.isQualitativeMode ? 'My Rating' : 'My Score'}</TableHeader>;
};
